import React, { useRef } from "react";

import { yupResolver } from "@hookform/resolvers/yup";
import ReCAPTCHA from "react-google-recaptcha";
import { useForm } from "react-hook-form";

import RegistrationForm from "./components/RegistrationForm";
import { registerSchema } from "./lib/RegistrationFormSchema";

import { store } from "../../..";
import "../../../assets/css/umphub/pages/contact.scss";
import { globalActions } from "../../../features/global/globalSlice";
import { useAppDispatch } from "../../../hooks/reduxHooks";
import { IRegisterUserData } from "../../../types/forms";

export const loader = async () => {
    const { settings } = store.getState().global;
    const promises = [];

    !settings.length &&
        promises.push(store.dispatch(globalActions.getSettings()));

    await Promise.all(promises);

    return null;
};

const Register = (): React.JSX.Element => {
    const dispatch = useAppDispatch();
    const recaptcha = useRef<ReCAPTCHA>(null);
    const methods = useForm<IRegisterUserData>({
        mode: "onChange",
        resolver: yupResolver(registerSchema),
    });

    return (
        <RegistrationForm
            dispatch={dispatch}
            methods={methods}
            recaptcha={recaptcha}
        />
    );
};

export default Register;
